import { useState } from "react";
import ImageUploader from "../../component/InventoryUI/ImageUploader";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

export default function ProfileForm({
  step,
  formData,
  setFormData,
  error,
  setError,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "telephone") {
      // Only digits allowed
      if (!/^\d*$/.test(value)) return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div>
      {step === 0 && (
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-semibold mb-1">Email</label>
            <input
              type="text"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
            />
          </div>

          {/* Password Field */}
          <div>
            <label className="block text-sm font-semibold mb-1">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94] pr-10"
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute inset-y-0 right-3 flex items-center text-gray-500"
              >
                {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
              </button>
            </div>
          </div>

          {/* Confirm Password Field */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              Confirm Password
            </label>
            <div className="relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94] pr-10"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                className="absolute inset-y-0 right-3 flex items-center text-gray-500"
              >
                {showConfirmPassword ? (
                  <AiOutlineEye />
                ) : (
                  <AiOutlineEyeInvisible />
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {step === 1 && (
        <>
          <h2 className="text-xl font-bold text-[#7f6bc6] mb-4">
            Profile Info
          </h2>
          {/* <div className="grid grid-cols-2 gap-4">
            {[
              "name",
              "title",
              "company",
              "telephone",
              "address",
              "linkedin",
              "website",
            ].map((key) => (
              <div key={key}>
                <label className="block text-sm font-semibold mb-1 capitalize">
                  {key}
                </label>
                <input
                  type="text"
                  name={key}
                  value={formData[key]}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
                />
              </div>
            ))}
          </div> */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold mb-1 capitalize">
                Name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold mb-1 capitalize">
                Designation
              </label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold mb-1 capitalize">
                Company
              </label>
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold mb-1 capitalize">
                Phone number
              </label>
              <input
                type="text"
                name="telephone"
                value={formData.telephone}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold mb-1 capitalize">
                Address
              </label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold mb-1 capitalize">
                Linkedin (link)
              </label>
              <input
                type="text"
                name="linkedin"
                value={formData.linkedin}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold mb-1 capitalize">
                Website (link)
              </label>
              <input
                type="text"
                name="website"
                value={formData.website}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
              />
            </div>
          </div>

        </>
      )}


      {step === 2 && (
        <>
          <h2 className="text-xl font-bold text-[#7f6bc6] mb-4">
            Upload Profile Image
          </h2>
          <ImageUploader
            selectedImage={formData.image}
            setSelectedImage={(file) =>
              setFormData((prev) => ({ ...prev, image: file }))
            }
            error={error}
            setError={setError}
          />
        </>
      )}
    </div>
  );
}
